import { render, staticRenderFns } from "./type-ahead.vue?vue&type=template&id=0feff6ae"
import script from "./type-ahead.vue?vue&type=script&lang=js"
export * from "./type-ahead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports